<template>
    <div class="vehicles-list__item" v-if="carddata != undefined">
        <div class="vehicles-list__item-info">                                                    
            <strong><div class="vehicles-list__item-details">{{ cardtypedesc }} ending in {{ carddata.last4digits }}</div></strong>
            <div class="vehicles-list__item-details">Expiration: {{ expirydate }}</div>
            
            <!-- <div class="form-row payment-methods__preferred">														
                <span class="payment-methods__item-radio input-radio">
                    <span class="input-radio__body">
                        <input class="input-radio__input" name="checkout_payment_method" type="radio" @change="updateDefaultCC" v-model="isDefault" :checked='isDefault'>
                        <span class="input-radio__circle"></span>
                    </span>
                </span>	
                <span class="payment-methods__item-title payment-methods__preferred-text">Preferred payment method</span>
            </div> -->
        </div>
        <button type="button" class="vehicles-list__item-remove"  @click="$emit('remove-card', index)">
            <svg width="16" height="16">
                <path d="M2,4V2h3V1h6v1h3v2H2z M13,13c0,1.1-0.9,2-2,2H5c-1.1,0-2-0.9-2-2V5h10V13z" />
            </svg>
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            isDefault: false,
        }
    },
    props: {
        index: {
            type: Number,
            required: true
        },
        carddata: {
            type: Object,
            required: true
        }
    },
    emits: ['remove-card'],
    computed: {
        cardtypedesc() {
            if (this.carddata === undefined) {
                return '';
            } else {
                switch (this.carddata.tendertype) {
                    case 'VS':
                        return 'Visa';
                    case 'MC':
                        return 'Mastercard';
                    default: 
                        return 'Undefined type';
                }
            }
        },
        expirydate() {
            if (this.carddata === undefined) {
                return '';
            } else {
                return this.carddata.expirymonth + '/' + this.carddata.expiryyear;
            }
        },
        ...mapGetters([
			'customerDefaultCC'
        ]),
    },
    methods: {
        // on check of this item
        // update the  customer default cc
        // this will be use on B2B  checkout payment method
        updateDefaultCC() {
            this.$store.dispatch("setcustomerDefaultCC", {
                savednumber: this.carddata.savednumber,
                last4digits: this.carddata.last4digits,
            });
            // @TODO: To call a  webservice  to save the default cc
        }
    },
    created() {
        // set the default cc if saved previously
        if (this.carddata.savednumber == this.customerDefaultCC.savednumber){
            this.isDefault = true;
        }
    }
}
</script>